import React from "react";
import "../../styles/SalesFunnel.css";
import { Link } from "react-router-dom";
import { FaTrain, FaCheckCircle, FaPhoneAlt } from "react-icons/fa";
import Seoservice from "../../Page-section/Seo/Seoservice";
import Faq from "../../Page-section/Seo/Faq";
import Portfolio from "../../components/portfolio";

import {
  FaLightbulb,
  FaUsers,
  FaAward,
  FaCode,
  FaCogs,
  FaPaperPlane,
} from "react-icons/fa";

const Seoprocess = () => {
  const points = [
    "   Increased website traffic ",
    "   Better brand visibility ",
    "   Higher credibility and trust ",
    "   Improved user experience ",
    "   Long-term ROI ",
  ];
  const point = [
    "Increase Organic Traffic",
    "Generate Quality Leads",
    "Improve Conversion Rates",
    "Build Brand Authority",
  ];

  const steps = [
    {
      id: 1,
      title: "Website Audit",
      color: "green",

      icon: <FaLightbulb />,
      desc: "We analyze your website to perceive issues and opportunities.",
    },
    {
      id: 2,
      title: "Keyword Research",
      color: "#0868a0",
      icon: <FaUsers />,
      desc: "Our group conducts in-intensity key-word research to find excessive-traffic.",
    },
    {
      id: 3,
      title: "Strategy Planning",
      color: "green",
      icon: <FaCode />,
      desc: "We create a custom designed SEO method primarily based in your goals.",
    },
    {
      id: 4,
      title: "Implementation",
      color: "#0868a0",
      icon: <FaCogs />,
      desc: "We optimize your website the usage of proven strategies.",
    },
    {
      id: 5,
      title: "Link Building",
      color: "green",
      icon: <FaAward />,
      desc: "Our team builds high-quality backlinks from trusted websites to increase your domain authority.",
    },
    {
      id: 6,
      title: "Monitoring & Optimization",
      color: "#0868a0",
      icon: <FaPaperPlane />,
      desc: "Our seo expert in Noida  constantly monitors overall performance and makes improvements.",
    },
  ];
  return (
    <section className="sf-wrapper">
      <div className="sf-sidebar">
        <div className="sf-card">
          <h2>Our Services</h2>

          <ul className="sf-service-list">
            <li className="active">
              <Link to="/seo-agency-noida">SEO Services</Link>
            </li>
            <li>
              <Link to="/web-development-company-in-noida">
                Web Development
              </Link>
            </li>
            <li>
              <Link to="/web-design-services">Web Design</Link>
            </li>
            <li>
              <Link to="/social-media-marketing-services">
                Social Media Marketing
              </Link>
            </li>
            <li>
              <Link to="/content-marketing-services">Content Marketing</Link>
            </li>
            <li>
              <Link to="/ai-automation-services">AI Automation Services</Link>
            </li>

            <li>
              <Link to="/lead-generation-services">Lead Generation</Link>
            </li>
            <li>
              <Link to="/sales-funnel-optimization">
                Sales Funnel Optimization
              </Link>
            </li>
            <li>
              <Link to="/branding-agency-noida">Branding Services</Link>
            </li>
            <li>
              <Link to="/business-automation-services">
                Business Automation
              </Link>
            </li>
            <li>
              <Link to="/resources">Resources</Link>
            </li>
          </ul>
        </div>

        <div className="sf-card">
          <h2>Contact Info</h2>

          <div className="sf-contact">
            <p>Address :- Sector-62, Noida, India</p>
            <p>
              Phone :- <br />
              <a href="tel:+918368327503"> +91 8368327503</a> |{" "}
              <a href="tel:+919319563429"> +91 9319563429</a>
            </p>
            <p>
              Email :- <br />
              <a href="mailto:connect@empowerweb.in">connect@empowerweb.in</a>
            </p>
          </div>
        </div>
        <Portfolio />
      </div>
      <div className="sf-main-content">
        <section className="why-container">
          <div className="why-content">
            <h2>Why SEO is Important for Your Business</h2>

            <p>
              Search Engine Optimization (SEO) is one of the most effective
              virtual advertising and marketing strategies for lengthy-time
              period boom. A expert{" "}
              <b>search engine optimization company in Noida </b> enables your
              enterprise appear in front of ability customers whilst they are
              actively attempting to find your services. Here are a few key
              advantages of SEO:
            </p>

            <ul>
              {points.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>

            <p>
              Working with the <b>best seo company in noida </b> guarantees that
              your commercial enterprise remains beforehand of competition and
              achieves sustainable boom.
            </p>
          </div>
        </section>
        <section className="freight-container">
          <div className="freight-content">
            <h3>What Makes Us the Best SEO Partner?</h3>
            <p>
              Choosing the right{" "}
              <b>search engine optimization company in Noida </b> can make a
              massive distinction for your online success. Here’s why we stand
              out:
            </p>
            <div className="freight-boxes">
              <div className="box">
                <div className="icon">
                  <FaTrain />
                </div>
                <div>
                  <h4>Data-Driven Strategies</h4>
                  <p>
                    We use analytics and insights to create powerful SEO
                    campaigns that supply effects.
                  </p>
                </div>
              </div>
              <div className="box">
                <div className="icon">
                  <FaCheckCircle />
                </div>
                <div>
                  <h4>Experienced Team</h4>
                  <p>
                    Our group includes skilled specialists and a relied on{" "}
                    <b>seo expert in Noida </b> who guarantees your website
                    follows the state-of-the-art search engine marketing
                    pointers.
                  </p>
                </div>
              </div>
              <div className="box">
                <div className="icon">
                  <FaPhoneAlt />
                </div>
                <div>
                  <h4>Affordable Pricing </h4>
                  <p>
                    We provide value-powerful applications, making us the
                    first-class search engine optimization offerings in Noida
                    provider for groups of all sizes.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <Seoservice />
        <section className="work-process-section">
          <h3 className="work-title">Our SEO Process</h3>
          <p className="work-subtitle">
            We follow a structured SEO process to ensure success:
          </p>

          <div className="process-wrapper">
            {/* STEP LABELS */}
            <div className="process-line">
              {steps.map((step) => (
                <div
                  key={step.id}
                  className="process-step"
                  style={{ backgroundColor: step.color }}
                >
                  {step.title}
                </div>
              ))}
            </div>

            {/* STEP DETAILS */}
            <div className="process-grid">
              {steps.map((step) => (
                <div className="process-item" key={step.id}>
                  <div
                    className="process-iconv"
                    style={{ borderColor: step.color, color: step.color }}
                  >
                    {step.icon}
                  </div>
                  <h3 className="process-num" style={{ color: step.color }}>
                    {step.id.toString().padStart(2, "0")}
                  </h3>
                  <p className="process-text">{step.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </section>
        <section className="why-container">
          <div className="why-content">
            <h2>How SEO Helps Your Business Grow</h2>

            <p>
              Partnering with a professional seo agency in Noida can remodel
              your on line presence. Here’s how:
            </p>

            <ul>
              {point.map((item, index) => (
                <li key={index}>
                  <span className="check">✔</span> {item}
                </li>
              ))}
            </ul>
          </div>
        </section>
        <section className="benefits-section">
          <div className="container">
            <div className="header">
              <span className="tag">Why Choose Us</span>
              <div className="title-row">
                <h3>Why Choose Us?</h3>
                <p>
                  There are many options in relation to choosing a search engine
                  optimization company in Noida, but here’s why clients agree
                  with us:
                </p>
              </div>
            </div>

            <div className="cards">
              <div className="card">
                <h3>Proven track record </h3>
              </div>
              <div className="card">
                <h3> Experienced team </h3>
              </div>
              <div className="card">
                <h3> Result-oriented approach </h3>
              </div>
              <div className="card">
                <h3> Transparent communication </h3>
              </div>
              <div className="card">
                <h3> Affordable pricing </h3>
              </div>
            </div>
          </div>
        </section>
        <Faq />
        <section className="operations-wrapper">
          <div className="operations-left">
            <h3>Get Started Today</h3>
          </div>
          <div className="operations-right">
            <p>
              If you're seeking to grow your commercial enterprise on line,
              associate with a relied on seo agency in Noida. Our professional
              crew is prepared to help you improve scores, power visitors, and
              increase conversions.
            </p>
          </div>
        </section>
      </div>
    </section>
  );
};

export default Seoprocess;
